import styles from '../Styles/SectionTitle.module.css';

const SectionTitle = ({ title, subtitle, highlight = '', align = 'center', light = false }) => {
  const renderTitle = () => {
    if (!highlight) return title;

    const parts = title.split(highlight);
    return (
      <>
        {parts[0]}
        <span className={styles.titleHighlight}>{highlight}</span>
        {parts[1]}
      </>
    );
  };

  return (
    <div className={`${styles.sectionTitle} ${styles[align]}`}>
      <h2 className={`${styles.title} ${light ? styles.titleLight : ''}`}>
        {renderTitle()}
      </h2>
      <span className={styles.titleUnderline} />
      {subtitle && (
        <p className={`${styles.subtitle} ${light ? styles.subtitleLight : ''}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;